import PageLayout from "../layout/page";
import { arrowLeft } from "../../constant/icons";
import { Button, Col, FormGroup, Label, Row } from "reactstrap";
import { formatDateForApi, useApp } from "../../components/app";
import { useNavigate } from "react-router-dom";
import { DataView } from "../../components/table/table";
import { ErrorMessage, Field, Form, Formik } from "formik";
import reactSelect from "react-select";
import ReactDatePicker from "react-datepicker";
import { useApi } from "../../helper/apiHook";
import { useEffect, useMemo, useState } from "react";
import { ActionType, DataType } from "ka-table";
import { post } from "../../helper/api";
import { useLoaderHelper } from "../../helper/loaderHelper";
import { getDate } from "../../helper/utility";

const DeleteList = (props: any) => {
  const app = useApp();
  const [filters, setFilters] = useState<any>({});
  const loader = useLoaderHelper();
  const api = useApi("getValues", true, filters, {
    revalidateOnFocus: true,
    revalidateIfStale: true,
  });
  const { isDeleteByReference } = props;
  const [viewDelete, setViewDelete] = useState(false);
  const [selectedId, setSelectedId] = useState<any[]>([]);
  let navigate = useNavigate();

  if (!app.conversation) {
    navigate("/");
  }

  const resendColumns = useMemo(() => {
    if (api?.data?.data?.columnsList) {
      let column: any = (api?.data?.data?.columnsList as []).filter(
        (x: any) => x.actionKey && x.key !== "selection-cell" // Exclude selection-cell
      );
      if (column) {
        column = column?.map((item: any) => item.key);
        console.log("resendColumns: filtered columns", column);
        return column;
      }
      return ["id"];
    }
    return ["id"];
  }, [api?.data?.data?.columnsList]);

  const dataOfRow = useMemo(() => {
    if (api?.data?.data?.data && Array.isArray(api?.data?.data?.data)) {
      const rows = api?.data?.data?.data.map((item: any, index: any) => {
        item.tableId = index;
        item.srNo = index + 1; // Ensure srNo is added
        console.log(`Row ${index}:`, item); // Log each row
        return item;
      });
      console.log("dataOfRow: ", rows); // Log all rows
      return rows;
    }
    setSelectedId([]);
    return [];
  }, [api?.data?.data?.data]);

  const columnsWithSrNo = useMemo(() => {
    const selectionColumn = {
      key: "selection-cell",
      title: "",
      dataType: DataType.Boolean,
      width: "50px",
    };
    const srNoColumn = {
      key: "srNo",
      title: "Sr. No",
      dataType: DataType.Number,
      width: "70px",
    };
    const additionalColumns = (api?.data?.data?.columnsList || []).filter(
      (col: any) => col.key !== "selection-cell" // Exclude duplicate selection-cell
    );
    const allColumns = [selectionColumn, srNoColumn, ...additionalColumns];
    console.log("columnsWithSrNo: ", allColumns); // Log all columns
    return allColumns;
  }, [api?.data?.data?.columnsList]);

  const onSelectionChange = (selectedType: string, rowId: string | string[]) => {
    const singleRowId = Array.isArray(rowId) ? rowId[0] : rowId;
    if (selectedType === ActionType.SelectRow) {
      let row = dataOfRow?.find((item: any) => item["tableId"] == rowId);
      if (row) {
        let values: any = { tableId: singleRowId };
        resendColumns.forEach((item: any) => {
          values[item] = row[item];
        });
        setSelectedId((prevSelectedId) => [...prevSelectedId, values]);
      }
    } else if (selectedType === ActionType.DeselectRow) {
      setSelectedId((prevSelectedId) => [
        ...prevSelectedId.filter((x: any) => x.tableId != singleRowId),
      ]);
    } else if (selectedType === ActionType.SelectAllFilteredRows || selectedType === ActionType.SelectAllRows) {
      let newSelectedId: any[] = [];
      dataOfRow.forEach((element: any) => {
        let values: any = { tableId: element.tableId };
        resendColumns.forEach((item: any) => {
          values[item] = element[item];
        });
        newSelectedId.push(values);
      });
      setSelectedId(newSelectedId);
    } else if (selectedType === ActionType.DeselectAllFilteredRows || selectedType === ActionType.DeselectAllRows) {
      setSelectedId([]);
    }
  };

  useEffect(() => {
    setViewDelete(selectedId.length > 0);
  }, [selectedId.length, selectedId]);

  const onDeleteDate = async (functionCode: string | undefined) => {
    if (functionCode) {
      const resultOfDeleteValues = await post(
        "/deleteValues",
        {
          functionCode: functionCode,
          tenantId: app.conversation?.tenant?.[0]?.id || 0,
          Ids: selectedId,
        },
        undefined,
        loader
      );
      if (resultOfDeleteValues?.status) {
        navigate("/job");
      } else {
        api?.mutate();
      }
    }
  };

  return (
    <>
      <Formik
        initialValues={{
          function: undefined,
          dateType: undefined,
          fromDate: undefined,
          toDate: undefined,
        }}
        onSubmit={(values, actions) => {
          setFilters({
            functionCode: values.function || "",
            dateType: values.dateType || "",
            tenantId: app.conversation?.tenant?.[0]?.id || 0,
            fromDate: values.fromDate ? formatDateForApi(values.fromDate) : undefined,
            toDate: values.toDate ? formatDateForApi(values.toDate) : undefined,
          });
          api.mutate();
        }}
      >
        {(formProps) => (
          <Form className="mx-0 delete_search mb-3">
            <Row>
              <Col lg={3}>
                <FormGroup className="form-floating sticky_label mb-0">
                  <Field
                    name="function"
                    component={reactSelect}
                    className="column_field_select"
                    menuPortalTarget={document.body}
                    menuPlacement="auto"
                    menuPosition={"fixed"}
                    onChange={(newValue: any) => {
                      formProps.setFieldValue("function", newValue.value);
                    }}
                    options={app.functionDropDownList(undefined)}
                    placeholder={<div>Select column field</div>}
                  />
                  <ErrorMessage
                    name="function"
                    component="div"
                    className="text-danger"
                  />
                  <Label>Function List</Label>
                </FormGroup>
              </Col>
              <Col lg={3}>
                <FormGroup className="form-floating sticky_label mb-0">
                  <Field
                    name="dateType"
                    component={reactSelect}
                    className="column_field_select"
                    menuPortalTarget={document.body}
                    menuPlacement="auto"
                    menuPosition={"fixed"}
                    onChange={(newValue: any) => {
                      formProps.setFieldValue("dateType", newValue.value);
                    }}
                    options={[
                      {
                        value: "create",
                        label: "Create Date",
                      },
                      {
                        value: "update",
                        label: "Update Date",
                      },
                    ]}
                    placeholder={<div>Select column field</div>}
                  />
                  <ErrorMessage
                    name="dateType"
                    component="div"
                    className="text-danger"
                  />
                  <Label>Date Type</Label>
                </FormGroup>
              </Col>
              <Col lg={3}>
                <FormGroup className="form-floating sticky_label mb-0 delete_reference_date">
                  <Field
                    name="fromDate"
                    component={ReactDatePicker}
                    placeholderText={"DD/MM/YYYY"}
                    dateFormat={"dd/MM/yyyy"}
                    className="form-control w-100"
                    selected={getDate(formProps.values?.fromDate)}
                    onChange={(date: any, _: any) => {
                      formProps.setFieldValue("fromDate", date);
                    }}
                  />
                  <ErrorMessage
                    name="fromDate"
                    component="div"
                    className="text-danger"
                  />
                  <Label>
                    From Date<span style={{ color: "red" }}>*</span>
                  </Label>
                </FormGroup>
              </Col>
              <Col lg={3}>
                <FormGroup className="form-floating sticky_label mb-0 delete_reference_date">
                  <Field
                    component={ReactDatePicker}
                    placeholderText={"DD/MM/YYYY"}
                    dateFormat={"dd/MM/yyyy"}
                    className="form-control"
                    name="toDate"
                    selected={getDate(formProps.values?.toDate)}
                    onChange={(date: any, _: any) => {
                      formProps.setFieldValue("toDate", date);
                    }}
                  />
                  <ErrorMessage
                    name="toDate"
                    component="div"
                    className="text-danger"
                  />
                  <Label>
                    To Date<span style={{ color: "red" }}>*</span>
                  </Label>
                </FormGroup>
              </Col>
              <Col lg={10} className="d-flex justify-content-end">
                {viewDelete && (
                  <Button
                    onClick={() => onDeleteDate(formProps?.values?.function)}
                  >
                    Delete Selected
                  </Button>
                )}
              </Col>
              <Col lg={2} className="d-flex justify-content-end">
                <Button>Search</Button>
              </Col>
            </Row>
          </Form>
        )}
      </Formik>
      <DataView
        columns={dataOfRow?.length > 0 ? columnsWithSrNo : []}
        rows={dataOfRow}
        rowCount={api?.rowCount}
        currentPage={api?.currentPage}
        limit={api?.limit}
        keyId={"tableId"}
        onSelectionChange={onSelectionChange}
        allRows={dataOfRow}
      />
    </>
  );
};
export { DeleteList };